import React, { useContext } from 'react';

import { SettingsContext } from '../../contexts';
import { Date } from '../../components';
import { formatRequestId } from '../../order/helpers';
import OrderStatus from '../../components/order/Status';

export function RequestRow({ item: request }) {
  const { settings } = useContext(SettingsContext);

  return (
    <>
      <tr className="desktop">
        <td className="pl-2">{formatRequestId(settings, request)}</td>
        <td className="capitalize">{request.request_type}</td>
        <td>{request.product?.brand?.name}</td>
        <td>{request.product?.model?.name}</td>
        <td>{request.product?.reference_number}</td>
        <td><OrderStatus status={request.status} /></td>
        <td><Date date={request.created_at} /></td>
      </tr>

      <tr className="mobile">
        <td>
          <div className="row p-15">
            <div className="col-12">Request ID: <strong>{formatRequestId(settings, request)}</strong></div>
            <div className="col-12 capitalize">Request Type: <strong>{request.request_type}</strong></div>
            <div className="col-12 mt-2">
              <strong>
                {request.product?.brand?.name}&nbsp;
                {request.product?.model?.name}
              </strong>
              <br />
              {request.product?.reference_number}
            </div>
            <div className="col-12 mt-2">Status: <strong className="d-inline-block"><OrderStatus status={request.status} /></strong></div>
            <div className="col-12">Date: <strong><Date date={request.created_at} /></strong></div>
          </div>
        </td>
      </tr>
    </>
  );
}
